/*eslint-disable*/
import React, { Fragment } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteSchedule,
  updateSchedule,
  updateScheduleFB,
  deleteScheduleFB,
} from "./redux/modules/calendar";
import Schedule from "./Schedule";

const Modal = ({ isModalOpen, close, target, history }) => {
  const dispatch = useDispatch();
  const schedules = useSelector((state) => state.calendar.schedules);

  const findSchedule = schedules.map((schedule) => {
    if (schedule.desc === target) {
      return (
        <Container>
          <Title
            style={{
              color: schedule.completed ? "#999" : "#7f49c8",
            }}
          >
            {schedule.completed ? "완료된 일정" : "예정된 일정"}
          </Title>
          <Content>
            <p>{schedule.date.substr(0, 10)}</p>
            <p>{schedule.date.substr(11, 16)}</p>
            <p style={{ fontWeight: "1000" }}>{schedule.desc}</p>
            <StateBtn>
              <button
                style={{ borderRadius: "8px 0 0 8px" }}
                onClick={() => {
                  dispatch(deleteScheduleFB(schedule.desc));
                  history.push("/");
                }}
              >
                삭제
              </button>

              <button
                onClick={() => {
                  dispatch(updateScheduleFB(schedule.desc));

                  history.push("/");
                }}
                style={{ borderRadius: "0 8px 8px 0" }}
              >
                완료
              </button>
            </StateBtn>
          </Content>
          <ButtonWrap>
            <button onClick={close}> Confirm </button>
          </ButtonWrap>
        </Container>
      );
    } else null;
  });
  return (
    <>
      {isModalOpen ? (
        <React.Fragment>
          <ModalOverlay onClick={close} />
          {findSchedule}
        </React.Fragment>
      ) : null}
    </>
  );
};

const ModalOverlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.16);
`;

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65vw;
  max-width: 545px;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 20px;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

const Title = styled.p`
  font-size: 0.7em;
  font-weight: 600;
  color: #999;
`;

const Content = styled.div`
  border-top: 1px solid #bebebe;
  margin-top: 16px;
  padding: 10px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & p {
    padding: 8px;
    margin: 0;
    font-size: 0.7em;
    color: #4d4887;
  }
`;

const StateBtn = styled.div`
  margin: 18px 0 10px 0;
  width: 20%;
  height: 30%;
  display: flex;
  font-weight: 800;
  & button {
    min-width: 28px;
    font-size: 0.5em;
    font-weight: 800;
    width: 50%;
    height: 100%;
    padding: 3px;
    border: 1px solid #fff;
    background-color: #dce1f2;
    color: #444078;
  }
`;

const ButtonWrap = styled.div`
margin: 0;
margin-top: 8px;
      & button{
        width: 100%;
        padding: 12px 0;
        border-radius: 0 0 10px 10px;
        background-color: #4D4887;
        font-size: 13pt;
        color: white;
        border: 0;
        cursor: pointer;
        &:hover{
          background-color: #7f49c8;
        }
        &:active{
          background-color: #7e49c8;
        }
`;

export default withRouter(Modal);
